<template>
  <header class="bg-white shadow-sm border-b border-gray-200">
    <div class="px-6 py-4 flex items-center justify-between">
      <div class="flex items-center">
        <h1 class="text-xl font-semibold text-gray-900">{{ pageTitle }}</h1>
      </div>

      <div class="flex items-center space-x-4">
        <!-- 域名选择器 -->
        <DomainSelector v-if="!isConfigPage" />

        <LanguageSwitch variant="light" />

        <!-- 用户信息 -->
        <div class="flex items-center space-x-2 text-sm text-gray-600">
          <UserCircleIcon class="h-5 w-5" />
          <span>{{ configStore.email || 'API Token' }}</span>
        </div>

        <!-- 配置按钮 -->
        <button
          @click="router.push('/config')"
          class="p-2 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100"
          title="Settings"
        >
          <Cog6ToothIcon class="h-5 w-5" />
        </button>
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useConfigStore } from '../../stores/config';
import { useI18nStore } from '../../stores/i18n';
import { UserCircleIcon, Cog6ToothIcon } from '@heroicons/vue/24/outline';
import DomainSelector from '../common/DomainSelector.vue';
import LanguageSwitch from '../common/LanguageSwitch.vue';

const route = useRoute();
const router = useRouter();
const configStore = useConfigStore();
const i18n = useI18nStore();

const pageTitle = computed(() => {
  if (route.meta.titleKey) {
    return i18n.t(route.meta.titleKey);
  }

  return i18n.t('common.brand');
});

const isConfigPage = computed(() => route.name === 'Config');
</script>
